import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, } from '@chakra-ui/react';
import { DragDrawerContent } from './Drag/DragDrawerContent';
import { RenderInDesktop, RenderInMobile } from './MobileOrDesktop';
export const ModalOrDrawer = hocModalOrDrawer('ModalOrDrawer', Drawer, Modal);
export const ModalOrDrawerContent = hocModalOrDrawer('ModalOrDrawerContent', DrawerContent, ModalContent);
export const ModalOrDragDrawerContent = hocModalOrDrawer('ModalOrDragDrawerContent', DragDrawerContent, ModalContent);
export const ModalOrDrawerOverlay = hocModalOrDrawer('ModalOrDrawerOverlay', DrawerOverlay, ModalOverlay);
export const ModalOrDrawerBody = hocModalOrDrawer('ModalOrDrawerBody', DrawerBody, ModalBody);
export const ModalOrDrawerHeader = hocModalOrDrawer('ModalOrDrawerHeader', DrawerHeader, ModalHeader);
export const ModalOrDrawerFooter = hocModalOrDrawer('ModalOrDrawerFooter', DrawerFooter, ModalFooter);
export const ModalOrDrawerCloseButton = hocModalOrDrawer('ModalOrDrawerCloseButton', DrawerCloseButton, ModalCloseButton);
function hocModalOrDrawer(name, DrawerPart, ModalPart) {
    const Hoc = (props) => {
        return (_jsxs(_Fragment, { children: [_jsx(RenderInMobile, { children: _jsx(DrawerPart, { ...props }) }), _jsx(RenderInDesktop, { children: _jsx(ModalPart, { ...props }) })] }));
    };
    Hoc.displayName = name;
    // Hoc.defaultProps = {} as Partial<D & M>;
    return Hoc;
}
